import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import { Dialog } from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Memo } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';

const modeInfo = {
  add: {
    title: '新增實際進度',
  },
  edit: {
    title: '編輯實際進度',
  },
  view: {
    title: '檢視實際進度',
  },
};

class AddAndEdit extends Component {
  constructor (props) {
    super(props);
    this.state = {
      data: JSON.parse(JSON.stringify(props.data)),
      old_data: JSON.parse(JSON.stringify(props.data)),
      mode: '',
      canSend: true,
      errorAry: [],
    };
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      actural_date: data.actural_date || '',
      actural_num: data.actural_num || '',
      actural_unit: data.actural_unit || '',
      note: data.note || '',
      id: data.id || '',
    };
    return body;
  }

  add=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.actural_date) === '', // 0
      returnInputValue(data.actural_num) === '', // 0
      returnInputValue(data.note) === '', // 0
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const { mode = '' } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;

    return (
      <div style={{ width: '741', height: '565', backgroundColor: 'white', borderRadius: 39, padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo[mode].title} center />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText bol text='日期' haveChange={checkChange('actural_date')} />
              <EAA_Date disabled={disabled} displayBorder value={getTime.returnDate(data.actural_date)} onChange={data => this.changeData({ label: 'actural_date', data: getTime.getType3Time(data) })} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText text='請選擇日期' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText bol text='完成數量' haveChange={checkChange('actural_num')} />
              <EAA_Input disabled={disabled} displayBorder type='number' unit='支' value={returnInputValue(data.actural_num)} onChange={data => this.changeData({ label: 'actural_num', data })} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText bol text='備註' haveChange={checkChange('note')} />
              <EAA_Memo disabled={disabled} displayBorder value={returnInputValue(data.note)} onChange={data => this.changeData({ label: 'note', data })} />
            </EAA_ItemContainer>
            <div style={{ color: '#B00020', fontSize: 14, fontWeight: 500, marginLeft: 120 }}>註:說明與規劃不一致的理由</div>
            {errorAry[2] && <EAA_ErrorText text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  ExtendSupReason: state.data.ExtendSupReason,
});
const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
